<template>
  <div class="buyerShop">
    <el-form label-position="right" label-width="100px">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('crm.vendorId')">
                <el-input type="number" v-model.number="queryForm.inputVendorId" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('crm.vendorAlias')">
                <el-select v-model="queryForm.vendorAliasId" filterable clearable>
                  <el-option v-for="item in vendorList" :label="item.vendorNameAlias" :value="item.value" :key="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
          <el-button @click="search" type="primary">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-col>
      </el-row>
    </el-form>

    <div class="tr">
      <el-button type="primary" @click="showForm">创建</el-button>
    </div>

    <el-table :data="tableData" v-loading="loading">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column :label="$t('crm.vendorId')" prop="vendorId"></el-table-column>
      <el-table-column prop="vendorNameAlias" :label="$t('crm.vendorAlias')"></el-table-column>
      <el-table-column label="商品全量配置" prop="productAllUpdateJson">
        <template slot-scope="scope">
          <el-button v-if="scope.row.productAllUpdateJson" type="text" size="small" @click="showJson(scope.row.productAllUpdateJson)">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column label="商品增量配置" prop="productDeltaUpdateJson">
        <template slot-scope="scope">
          <el-button v-if="scope.row.productDeltaUpdateJson" type="text" size="small" @click="showJson(scope.row.productDeltaUpdateJson)">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column label="库存全量配置" prop="stockAllUpdateJson">
        <template slot-scope="scope">
          <el-button v-if="scope.row.stockAllUpdateJson" type="text" size="small" @click="showJson(scope.row.stockAllUpdateJson)">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column label="库存增量配置" prop="stockDeltaUpdateJson">
        <template slot-scope="scope">
          <el-button v-if="scope.row.stockDeltaUpdateJson" type="text" size="small" @click="showJson(scope.row.stockDeltaUpdateJson)">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column label="检查库存配置" prop="checkStockJson">
        <template slot-scope="scope">
          <el-button v-if="scope.row.checkStockJson" type="text" size="small" @click="showJson(scope.row.checkStockJson)">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column label="创建订单配置" prop="createOrderJson">
        <template slot-scope="scope">
          <el-button v-if="scope.row.createOrderJson" type="text" size="small" @click="showJson(scope.row.createOrderJson)">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column label="取消订单配置" prop="cancelOrderJson">
        <template slot-scope="scope">
          <el-button v-if="scope.row.cancelOrderJson" type="text" size="small" @click="showJson(scope.row.cancelOrderJson)">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column label="订单状态对接配置" prop="orderStatusSyncJson">
        <template slot-scope="scope">
          <el-button v-if="scope.row.orderStatusSyncJson" type="text" size="small" @click="showJson(scope.row.orderStatusSyncJson)">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column label="创建现货批发订单配置" prop="batchCreateOrderJson">
        <template slot-scope="scope">
          <el-button v-if="scope.row.batchCreateOrderJson" type="text" size="small" @click="showJson(scope.row.batchCreateOrderJson)">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column label="job-dispatcher类名" prop="classInfo"></el-table-column>
      <el-table-column label="api-boutique类名" prop="classInfoForApiBoutique"></el-table-column>
      <el-table-column :label="$t('common.action')" width="160">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editItem(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="tr mt10">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="queryForm.pageNo"
        small
        :page-sizes="[10, 25, 50, 100]"
        :page-size="queryForm.pageSize"
        layout="total,sizes,prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <div class="tr">
      <el-button type="primary" @click="showForm">新增</el-button>
    </div>

    <el-dialog :title="idEdit ? '编辑配置' : '新增配置'" :visible.sync="dialogVisible" width="600px">
      <el-form ref="form" :model="form" :rules="rules" label-width="170px">
        <el-form-item prop="vendorId" label="买手店">
          <el-select v-model="form.vendorId" :disabled="idEdit" filterable clearable>
            <el-option v-for="item in vendorList" :label="item.vendorNameAlias" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="productAllUpdateJson" label="商品全量配置">
          <el-input type="textarea" :rows="4" v-model="form.productAllUpdateJson"></el-input>
        </el-form-item>
        <el-form-item prop="productDeltaUpdateJson" label="商品增量配置">
          <el-input type="textarea" :rows="4" v-model="form.productDeltaUpdateJson"></el-input>
        </el-form-item>
        <el-form-item prop="stockAllUpdateJson" label="库存全量配置">
          <el-input type="textarea" :rows="4" v-model="form.stockAllUpdateJson"></el-input>
        </el-form-item>
        <el-form-item prop="stockDeltaUpdateJson" label="库存增量配置">
          <el-input type="textarea" :rows="4" v-model="form.stockDeltaUpdateJson"></el-input>
        </el-form-item>
        <el-form-item prop="checkStockJson" label="检查库存配置">
          <el-input type="textarea" :rows="4" v-model="form.checkStockJson"></el-input>
        </el-form-item>
        <el-form-item prop="createOrderJson" label="创建订单配置">
          <el-input type="textarea" :rows="4" v-model="form.createOrderJson"></el-input>
        </el-form-item>
        <el-form-item prop="cancelOrderJson" label="取消订单配置">
          <el-input type="textarea" :rows="4" v-model="form.cancelOrderJson"></el-input>
        </el-form-item>
        <el-form-item prop="orderStatusSyncJson" label="订单状态对接配置">
          <el-input type="textarea" :rows="4" v-model="form.orderStatusSyncJson"></el-input>
        </el-form-item>
        <el-form-item prop="batchCreateOrderJson" label="创建现货批发订单配置">
          <el-input type="textarea" :rows="4" v-model="form.batchCreateOrderJson"></el-input>
        </el-form-item>
        <el-form-item prop="classInfo" label="job-dispatcher类名">
          <el-input v-model.trim="form.classInfo"></el-input>
        </el-form-item>
        <el-form-item prop="classInfoForApiBoutique" label="api-boutique类名">
          <el-input v-model.trim="form.classInfoForApiBoutique"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="查看" :visible.sync="dialogVisible2" width="600px">
      <vue-json-pretty :data="currData" />
    </el-dialog>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import {
  getVendorListExcludeImPull,
  getBoutiqueConfigurationPage,
  saveBoutiqueConfiguration,
  updateBoutiqueConfigurationPage,
} from './api';

export default {
  components: {
    VueJsonPretty,
  },
  data() {
    function validateJSON(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }
      if (value.length < 5) {
        callback(new Error('请输入正确的json格式'));
        return;
      }
      if (!value.includes('{')) {
        callback(new Error('请输入正确的json格式'));
        return;
      }
      try {
        JSON.parse(value);
        callback();
      } catch (e) {
        callback(new Error('请输入正确的json格式'));
      }
    }

    return {
      vendorList: [],
      vendorAliasMap: {},
      queryForm: {
        vendorAliasId: null,
        inputVendorId: null,
        vendorId: null,
        pageNo: 1,
        pageSize: 25,
      },
      loading: false,
      tableData: [],
      total: 0,
      dialogVisible: false,
      form: {
        vendorId: null,
        productAllUpdateJson: '',
        productDeltaUpdateJson: '',
        stockAllUpdateJson: '',
        stockDeltaUpdateJson: '',
        checkStockJson: '',
        createOrderJson: '',
        cancelOrderJson: '',
        orderStatusSyncJson: '',
        batchCreateOrderJson: '',
        classInfo: '',
        classInfoForApiBoutique: '',
      },
      rules: {
        vendorId: [{ required: true, message: '请选择买手店' }],
        productAllUpdateJson: [{ validator: validateJSON, trigger: 'blur' }],
        productDeltaUpdateJson: [{ validator: validateJSON, trigger: 'blur' }],
        stockAllUpdateJson: [{ validator: validateJSON, trigger: 'blur' }],
        stockDeltaUpdateJson: [{ validator: validateJSON, trigger: 'blur' }],
        checkStockJson: [{ validator: validateJSON, trigger: 'blur' }],
        createOrderJson: [{ validator: validateJSON, trigger: 'blur' }],
        cancelOrderJson: [{ validator: validateJSON, trigger: 'blur' }],
        orderStatusSyncJson: [{ validator: validateJSON, trigger: 'blur' }],
        batchCreateOrderJson: [{ validator: validateJSON, trigger: 'blur' }],
      },
      idEdit: false,
      dialogVisible2: false,
      currData: {},
    };
  },
  created() {
    getVendorListExcludeImPull({
      productSourceTypes: [4],
    }).then(res => {
      if (res.data && res.data.data) {
        const vendorAliasMap = {};
        this.vendorList = res.data.data.map(item => {
          vendorAliasMap[item.vendorId] = item.vendorNameAlias;
          return {
            value: item.vendorId,
            vendorNameAlias: item.vendorNameAlias,
          }
        })
        this.vendorAliasMap = vendorAliasMap;
      }
    });
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.vendorAliasId = null;
      this.queryForm.inputVendorId = null;
      this.queryForm.vendorId = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      getBoutiqueConfigurationPage({
        ...this.queryForm,
        vendorId: this.queryForm.inputVendorId || this.queryForm.vendorAliasId || this.queryForm.vendorId,
      }).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
        this.loading = false;
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    showForm() {
      this.idEdit = false;
      this.form.vendorId = null;
      this.form.productAllUpdateJson = '';
      this.form.productDeltaUpdateJson = '';
      this.form.stockAllUpdateJson = '';
      this.form.stockDeltaUpdateJson = '';
      this.form.checkStockJson = '';
      this.form.createOrderJson = '';
      this.form.cancelOrderJson = '';
      this.form.orderStatusSyncJson = '';
      this.form.batchCreateOrderJson = '';
      this.form.classInfo = '';
      this.form.classInfoForApiBoutique = '';
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    editItem(row) {
      this.idEdit = true;
      this.form.vendorId = row.vendorId;
      this.form.productAllUpdateJson = row.productAllUpdateJson;
      this.form.productDeltaUpdateJson = row.productDeltaUpdateJson;
      this.form.stockAllUpdateJson = row.stockAllUpdateJson;
      this.form.stockDeltaUpdateJson = row.stockDeltaUpdateJson;
      this.form.checkStockJson = row.checkStockJson;
      this.form.createOrderJson = row.createOrderJson;
      this.form.cancelOrderJson = row.cancelOrderJson;
      this.form.orderStatusSyncJson = row.orderStatusSyncJson;
      this.form.batchCreateOrderJson = row.batchCreateOrderJson;
      this.form.classInfo = row.classInfo;
      this.form.classInfoForApiBoutique = row.classInfoForApiBoutique;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!(this.form.productAllUpdateJson || this.form.productDeltaUpdateJson ||
            this.form.stockAllUpdateJson || this.form.stockDeltaUpdateJson || this.form.checkStockJson ||
            this.form.createOrderJson || this.form.cancelOrderJson || this.form.orderStatusSyncJson ||
            this.form.batchCreateOrderJson
          )) {
            this.$message('请至少填写一个配置信息')
            return;
          }
          if (!this.repeatSave) {
            this.repeatSave = true;
            let request = saveBoutiqueConfiguration;
            if (this.isEdit) {
              request = updateBoutiqueConfigurationPage;
            }
            request(this.form).then(res => {
              this.repeatSave = false;
              if (res.data.success) {
                this.$message.success(this.form.userId ? '编辑成功' : '创建成功');
                this.dialogVisible = false;
                this.getTableData();
              } else {
                this.$message.error(res.data.data || res.data.message);
              }
            }).catch((err) => {
              this.repeatSave = false;
            })
          }
        } else {
          this.$message.error('请完善信息');
          return false;
        }
      });
    },
    showJson(json) {
      try {
        this.currData = JSON.parse(json);
        this.dialogVisible2 = true;
      } catch (error) {
        this.$message.error('json格式错误');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.buyerShop {
  padding: 20px;
}
.form-btn {
  margin-top: 40px;
}
.mt10 {
  margin-top: 10px;
}
.mb20 {
  margin-bottom: 20px;
}
.tr {
  text-align: right;
}
.f12 {
  font-size: 12px;
}
.red {
  color: red;
}
</style>
